import { gql } from '@apollo/client';

export const GET_PROFILE_INFO = gql`
  query MyQuery {
    getProfile {
      loggedIn
      personId
      personInfo {
        alternateEmail
        birthdate
        blacklistStatusBitsType
        company
        created
        email
        unreadNotificationCount
        title
        termsAccepted
        tagline
        registeredDate
        pendingApplicationCount
        notes
        moderatorFlag
        lastName
        modified
        displayName
        first
        firstName
        hasChildren
        gender
        headshot
        id
        incompleteActivityCount
        incompleteInvitationCount
        incompletePartyCount
        isAgeVerified
        isDeleted
        isExcludedFromExports
        isRegistrationInitiated
        isRegistryCompliant
        last
      }
      totalNotificationCount
      phoneNumber
      eventParticipationBitsMap
      countryCode
      addressInfo {
        addressAccuracy
        addressLat
        addressLong
        checksum
        city
        cityAccuracy
        cityLat
        cityLong
        countryId
        countryName
        created
        dma
        id
        isBlacklisted
        isGeocoded
        isValid
        modified
        postalAdditional
        postalCode
        stateOrProvince
        street1
        street2
        timezone
      }
    }
  }
`;
